module.exports = __webpack_public_path__ + "img/5.a604b0e7.svg";